import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/logo白字.png")